import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";
import { Loading, LoadTable } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";
import useFetchTableData from "../../custom_hooks/useFetchTableData";

// const GetLiveUsersData = gql`
//   query Live_User {
//     FindActiveUser {
//       _id
//       Unique_Id

//       Live_User {
//         Unique_Id
//         accType
//         firstName
//         mobileNumber
//         email
//         Type_Of_User
//         Is_Active
//         Root_User
//         createdAt
//         lastName
//         message
//       }
//       createdAt
//       updatedAt
//     }
//   }
// `;

const GetLiveUsersData = (fields) => {
  const query = gql`
    query Live_User {
      FindActiveUser {
        _id
        ${fields?.join(" ")}
      }
    }
  `;
  return query;
};

const LiveUsers = () => {
  const [formdata, setformdata] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const Refetch = useSelector((store) => store.FormFieldData.refresh);
  const dispatch = useDispatch();
  const key = "Live_Users";

  const [fetchLiveUserData, { loading: queryLoading, error, data, refetch }] = useLazyQuery(GetLiveUsersData([]));

  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  useEffect(() => {
    setIsLoading(true);
    let updateddata =
      data &&
      data.FindActiveUser?.map((e) => {
        let obj = { ...e.Live_User[0] };
        delete obj.__typename;
        return {
          ...obj,
          Is_Active: obj.Is_Active ? "YES" : "NO",
          createdAt: IsoToDateTime(e.createdAt),
          updatedAt: IsoToDateTime(e.updatedAt),
        };
      });
    setformdata(updateddata);
    setIsLoading(false);
  }, [data, isLoading]);

  const { loading,TableHeaders } =useFetchTableData(GetLiveUsersData, fetchLiveUserData, setIsLoading, key);

  // useEffect(() => {
  //   if (Refetch) {
  //     refetch();
  //     dispatch({ type: "Refetch", payload: false });
  //   }
  // }, [Refetch]);

  if (error?.message) {
    return (
      <>
        <HeaderDiv title={"Vendor Account Data"} />
        <p className="DataNotAvailable">{error.message}</p>
      </>
    );
  }

  return (
    <div>
      <HeaderDiv title="Live Users" MoreActions={{Is_Print:false}} />
      {queryLoading ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {queryLoading && <div className="loader-line-div" />}
          <LoadTable title="Live_Users" data={formdata} loading={isLoading} error={error} TableHeaders={TableHeaders} />
        </>
      )}
    </div>
  );
};

export default LiveUsers;
